import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';

export const fetchZones = (warehouseid, success) => {
  axios({
    method: 'GET',
    // data: { ISANo },
    url: `${ROOT_URL}v1/warehouse/${warehouseid}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      Warehouse_Zone,
    } = res.data;
    success(Warehouse_Zone);
  }, err => {
    alert(JSON.stringify(err.data));
  })
}

export const fetchBins = (binId, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/warehouse/zone/${binId}/section/`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      data,
    } = res;
    success(data);
  }, err => {
    alert(JSON.stringify(err.data));
  })
}

export const fetchLevels = ({
  warehouse_id,
  zone_id,
  section_id,
  product_id,
}, success) => {
  axios({
    method: 'GET',
    params: {
      warehouse_id,
      zone_id,
      section_id,
      product_id,
    },
    url: `${ROOT_URL}v1/warehouse/section_with_color`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      data,
    } = res;
    success(data);
  }, err => {
    alert(JSON.stringify(err.data));
  })
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/api.js